"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var native_1 = __importDefault(require("@emotion/native"));
exports.Header = native_1.default.Text(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 20,
        color: theme.headerTextColor || 'black',
    });
}, function (_a) {
    var selected = _a.selected;
    return (selected ? { fontWeight: 'bold' } : {});
});
exports.Name = native_1.default.Text(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 16,
        color: theme.headerTextColor || 'black',
    });
}, function (_a) {
    var selected = _a.selected;
    return (selected ? { fontWeight: 'bold' } : {});
});
exports.Label = native_1.default.Text(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: 18,
        color: theme.labelColor || 'black',
    });
});
